import { useQuery } from "@tanstack/react-query";

import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import type { WorkspaceAccount } from "common/types";

import type { AccountSSI } from "../types";

async function getAccountSSIRequest(
  workspaceId: string,
  accountId: string,
): Promise<AccountSSI> {
  const {
    ssi: { memberScore },
  } = await get(`workspaces/${workspaceId}/accounts/${accountId}/ssi`);

  return memberScore;
}

export default function useAccountSSI(account: WorkspaceAccount) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { data: accountSSI, isLoading: isLoadingAccountSSI } = useQuery({
    queryKey: getQueryKeys(workspaceId).accountsKeys.ssi(account.id),
    queryFn: () => getAccountSSIRequest(workspaceId, account.id),
    enabled: account.type === "user" && account.state === "LoggedIn",
  });

  return {
    accountSSI,
    isLoadingAccountSSI,
  };
}
